// Mobx
import { Store, VueStore, Watch } from "@mgs/ci2019-common/src/store";
// Api
import { Api } from "#/api";
import { ConversionWorldProductFilterState } from "./ConversionWorldProductFilterState";

@Store
export class ConversionWorldKonsiFilterState extends ConversionWorldProductFilterState {
  public async updateFilterData() {
    this.filterData = await Api.conversionWorldService.getKonsiFilters(
      this.filter
    );
  }
}
